import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../services/api.service';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, ClientSideRowModelModule, ValidationModule, PaginationModule, RowSelectionModule, RowDragModule, TooltipModule, RenderApiModule, GridReadyEvent } from 'ag-grid-community';
import { ConfirmDialogComponent } from '../../reusable/confirm-dialog/confirm-dialog.component';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectBranchId } from '../../../store/branch/branch.selectors';
import { take } from 'rxjs';
import { selectOrganisationId } from '../../../store/organisation/organisation.selectors';
import { MultiselectDropdownComponent } from '../../reusable/multiselect-dropdown/multiselect-dropdown.component';
import { SingleSelectDropdownComponent } from '../../reusable/single-select-dropdown/single-select-dropdown.component';

@Component({
  selector: 'app-create-user',
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, ToastrModule, AgGridAngular, ConfirmDialogComponent, BreadcrumbComponent,MultiselectDropdownComponent,SingleSelectDropdownComponent],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss',
  providers: [BsModalService]
})
export class CreateUserComponent {
  userForm!: FormGroup;
  selectedProfileFile!: File | null;
  selectedSignatureFile!: File | null;
  userData: any;
  user: any;
  imagePreview: any;
  signatureError: boolean = false;
  organizationsList: any[] = [];
  branchList: any[] = [];
  departmentList: any[] = [];
  roleList = []
  parentPage: any;
  breadcrumbItems: Array<{ label: string }> = [];
  @Output() modalClosed = new EventEmitter<void>();
  @ViewChild('cellTemplate', { static: true }) cellTemplate!: TemplateRef<any>;
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  @ViewChild(ConfirmDialogComponent) confirmDialog!: ConfirmDialogComponent;
  @Input() organizationName: string | undefined; 
  selectedRowData: any;
  gridApi!: GridApi;
  rowData: any[] = [];
  logoPreview: any = null;
  signaturePreview: any = null;
  private store = inject(Store<AppState>);
  columnDefs: any = [
    // {
    //   headerName: 'Profile Picture',
    //   field: 'image',
    //   tooltipField: 'image',
    //   tooltipValueGetter: (params: any) => params.value ? 'Profile Image' : 'No data',
    //   flex: 1,
    //   sortable: false,
    //   cellRenderer: (params: any) => {
    //     if (params.value && params.value.data.length > 0) {
    //       let binary = new Uint8Array(params.value.data);
    //       let base64String = btoa(binary.reduce((data, byte) => data + String.fromCharCode(byte), ''));
    //       return `<img src="data:image/png;base64,${base64String}" style="width: 35px; height: 35px; border-radius: 50%;" />`;
    //     } else {
    //       return `<img src="assets/default-profile.png" style="width: 35px; height: 35px; border-radius: 50%;" />`;
    //     }
    //   }
    // },
    {
      headerName: 'User Name', tooltipField: 'username', field: 'username', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Email Address', tooltipField: 'email', field: 'email', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Contact Number', tooltipField: 'mobile', field: 'mobile', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Status', field: 'is_active', tooltipField: 'is_active', valueGetter: (params: any) => params.data.is_active ? 'Disable' : 'Active', sortable: true, flex: 1
    },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params: any) => {
        return this.getHtml(params);
      },
      sortable: false,
      filter: false,
      flex: 1
    }
  ];

  modules = [ClientSideRowModelModule, ValidationModule, PaginationModule, RowSelectionModule, RowDragModule, TooltipModule, RenderApiModule];
  pagination = true;
  paginationPageSize = 1;
  gridOptions = {
    suppressMovableColumns: false,
    rowDragManaged: false,
    animateRows: true,
    enableBrowserTooltips: true,
  };
  organisationId: any = null;
  branchId: any = null;
  moduleList: any[] = [];
  tagList: any[] = [];
  globalTagList: any[] = [];
  isOrganisationSelected: boolean = false;

  constructor(
    public modalRef: BsModalRef,
    private fb: FormBuilder,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.userForm = this.fb.group({
      is_superuser: [false],
      first_name: [null, [Validators.required, Validators.maxLength(150)]],
      last_name: [null, [Validators.required, Validators.maxLength(150)]],
      username: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(/^[a-z0-9._-]+$/)]],
      password: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(128), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,128}$/)]],
      mobile: [null, [Validators.required, Validators.maxLength(15)]],
      email: [null, [Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/)]],
      is_staff: [false],
      is_active: [true],
      specialisation: ['', [Validators.maxLength(500)]],
      qualification: [null],
      mci_number: [null, [Validators.maxLength(50)]],
     
      first_password_change_done: [false],
      country_code: [+91, [Validators.required, Validators.maxLength(10)]],
      patient_tags: [{ value: [], disabled: true }],
      evitals_kyc_id: [null],
      years_of_experience: [null],
      year_of_passing:[null],
      keycloak_user_id: [null],
      organisation_id: [null, [Validators.required]],
     
      module_id:[[ ], [Validators.required]],
      tag_id:[[], Validators.required],
      global_tag_id:[[], Validators.required]
    });

    // Disable module_id initially until organization is selected
    this.userForm.get('module_id')?.disable();

    this.breadcrumbItems = [
      { label: this.parentPage },
      ...(this.organizationName ? [{ label: this.organizationName }] : []),
      { label: 'Create User' }
    ];

    this.userForm.get('username')?.valueChanges.subscribe((value: any) => {
      if (typeof value === 'string' && value !== value.toLowerCase()) {
        this.userForm.get('username')?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });

    this.asynchronousBehaviourDealing();
  }

  async asynchronousBehaviourDealing(): Promise<void> {
    // Run these 3 functions concurrently
    await Promise.all([
      this.getOrganisation(),
      this.getDepartments(),
      this.getRoles(),
      this.getTags(),
      this.getGlobalTags()
       
    ]);
    // Then, if userData exists, getUser
    if (this.userData) {
      await this.getUser();
    }
    // Then, select branchId and organisationId from store
    this.store.select(selectBranchId).pipe(take(1)).subscribe((branchId: any) => {
      this.branchId = branchId;
      this.store.select(selectOrganisationId).pipe(take(1)).subscribe((organosationId: any) => {
        if(!organosationId)return;
        this.organisationId = organosationId;
        this.userForm.patchValue({ organisation_id: this.organisationId });
        this.userForm.get('organisation_id')?.disable();
        this.isOrganisationSelected = true;
        this.userForm.get('module_id')?.enable();
        this.getBranches(this.organisationId)
        this.findModuleListByOrganization(this.organisationId);
      });
      // if(!this.branchId)return;
      // this.userForm.patchValue({ branch_id: this.branchId });
      // this.userForm.get('branch_id')?.disable();
      // this.getUsers()
    });
  }

  onSubmit() {
    if (this.userForm.valid) {
      const formData = new FormData();
      const formControls = this.userForm.controls;

      Object.keys(formControls).forEach((key) => {
        let value = formControls[key].value;

        if (value !== null && value !== undefined) {
          if (key === 'patient_tags') {
            if (!Array.isArray(value)) {
              value = value.split(',').map((v: any) => v.trim());
            }
            const formattedValue = `{${value.join(',')}}`;
            formData.append(key, formattedValue);
          }
          else if (typeof value === 'boolean') {
            formData.append(key, value ? 'true' : 'false');
          } else {
            formData.append(key, value);
          }
        }
      });

      if (this.selectedProfileFile) {
        formData.append('image', this.selectedProfileFile);
      }
      if (this.selectedSignatureFile) {
        formData.append('signature_scan', this.selectedSignatureFile);
      }
      if (this.userData) {
        console.log('!!!!', formData)
        // If editing, update the existing user
        this.apiService.patch(`user/update/${this.userData.id}`, formData).subscribe({
          next: (res: any) => {

            this.toastr.success('User updated successfully!', 'Success');
            this.closeModal();
            
          },
          error: (err) => {
            console.error('Error updating user:', err);
            this.toastr.error(err.error?.message || 'Failed to update user.', 'Error');
          }
        });
      } else {
        // If adding, create a new user
        this.apiService.post('user', formData).subscribe({
          next: (res: any) => {
            this.toastr.success('User created successfully!', 'Success');
            this.closeModal()
          },
          error: (err) => {
            console.error('Error creating user:', err);
            this.toastr.error(err.error?.message || 'Failed to create user.', 'Error');
          }
        });
      }
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setGridOption('context', { componentParent: this });
  }

  onProfileFileSelected(event: any) {
    this.selectedProfileFile = event.target.files[0] || null;
  }

  onSignatureFileSelected(event: any) {
    this.selectedSignatureFile = event.target.files[0] || null;
  }

  closeModal() {
    this.modalClosed.emit();
    this.modalRef.hide();
    this.cdr.detectChanges();
  }

  getOrganisation(): void {
    this.apiService.get('organisation').subscribe({
      next: (res: any) => {
        this.organizationsList = res.data;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }



 onOrganisationChange(selectedItem: any): void {
     const orgId = selectedItem.id; 
     this.isOrganisationSelected = true;
     this.userForm.get('module_id')?.enable();
     this.getBranches(orgId);
     this.findModuleListByOrganization(orgId);
 }


  getBranches(orgId: number): void {
    this.apiService.get(`branch/organization/${orgId}`).subscribe({
      next: (res: any) => {
        this.branchList = res.data;
        
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  findModuleListByOrganization(orgId: number): void {
    console.log('Finding modules for organization:', orgId);
    this.apiService.get(`module/organization/${orgId}`).subscribe({
      next: (res: any) => {
        this.moduleList = res.data;
        console.log('Modules fetched:', this.moduleList);

        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  getDepartments(): void {
    this.apiService.get('department').subscribe({
      next: (res: any) => {
        this.departmentList = res.data;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  getRoles(): void {
    this.apiService.get('role').subscribe({
      next: (res: any) => {
        this.roleList = res.data;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

    getTags(): void {
    this.apiService.get('tag').subscribe({
      next: (res: any) => {
        this.tagList = res.data;
         this.cdr.detectChanges();
        if (this.agGrid) {
          this.agGrid.api.refreshCells({ force: true });
        }
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  getGlobalTags(): void {
    this.apiService.get('globalTag').subscribe({
      next: (res: any) => {
        this.globalTagList = res.data;
        if (this.agGrid) {
          this.agGrid.api.refreshCells({ force: true });
        }
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  getHtml(params: any) {
    const view = this.cellTemplate.createEmbeddedView({
      rowData: params.data,
    });
    view.detectChanges();
    const div = document.createElement('div');
    if (view.rootNodes.length > 0) {
      div.appendChild(view.rootNodes[0]);
      return div;
    } else {
      console.error('view.rootNodes is empty');
      return '';
    }
  }

  getUsers(): void {
    this.apiService.get(`user/branch/${this.branchId}/users`).subscribe({
      next: (res: any) => {
        this.rowData = res.data;
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  editRow(rowData: any) {
    this.userData = rowData;
    this.getUser();
  }

  deleteRow(rowData: any) {
    this.selectedRowData = rowData;
    this.confirmDialog.openModal(rowData);
  }

  onConfirmDelete() {
    if (!this.selectedRowData) return;

    this.apiService.delete(`user/${this.confirmDialog.rowData.id}`).subscribe({
      next: () => {
        this.toastr.success('User deleted successfully!', 'Success');
        this.getUsers();
      },
      error: (err: any) => {
        console.error('Error deleting user:', err);
        this.toastr.error(err.error?.message || 'Failed to delete user.', 'Error');
      }
    });
  }

  async getUser(): Promise<void> {
    this.apiService.get(`user/${this.userData.id}`).subscribe({
      next: (res: any) => {
       
        this.getBranches(res.data.organisation_id);
        this.findModuleListByOrganization(res.data.organisation_id);
        this.userForm.patchValue(res.data);
        this.isOrganisationSelected = true;
        this.userForm.get('module_id')?.enable();
    
        // Patch tag_id from userData if available (from list view)
        if (this.userData.tag_id_array && this.userData.tag_id_array.length > 0) {
          this.userForm.patchValue({ tag_id: this.userData.tag_id_array });
        }

        if (this.userData.global_tag_id_array && this.userData.global_tag_id_array.length > 0) {
          this.userForm.patchValue({ global_tag_id: this.userData.global_tag_id_array });
        }

        console.log('User fetched successfully:', res.data);
        this.userData = res?.data;
        this.cdr.detectChanges();
        if (res.data.image) this.logoPreview = this.arrayBufferToBase64(res.data.image?.data) ?? null;
        if (res.data.signature_scan) this.signaturePreview = this.arrayBufferToBase64(res.data.signature_scan?.data) ?? null;
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  arrayBufferToBase64(buffer: any): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return 'data:image/png;base64,' + btoa(binary);
  }

  createAnotherUser(): void {
    this.userData = null;
    this.userForm.reset();
    this.cdr.detectChanges();
  }
}
